// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ButtonAdvisory_wrapper__1d4Zs","btn_chat":"ButtonAdvisory_btn_chat__1pXzh","icon_heart":"ButtonAdvisory_icon_heart__2DtDL"};